import { PersistentJobQueue } from "./PersistentJobQueue";
import { Kernel } from "./Kernel";
import { TileCache, TilePutIncRef, TileRemoveDecRef } from "./TileCache";

export class TileDownloaderBrowser extends PersistentJobQueue {
    constructor(
        kernel: Kernel,
        private readonly _tileCache: TileCache
    ) {
        super(kernel, "tile", 64);
    }

    protected override async syncEntry(key: string): Promise<void> {
        const response = await fetch(key, {
            method: "GET",
            mode: "cors",
            headers: {
                //"Cache-Control": "max-age=1000",
            },
        });
        const image = await response.blob();
        await this._tileCache.putTile(key, Date.now(), image, TilePutIncRef.Yes);
    }

    protected override async removeEntry(key: string): Promise<void> {
        await this._tileCache.removeTile(key, TileRemoveDecRef.Yes);
    }
}
